/**
 * BundlesPage — list of all bundles.
 */

import { useFilteredBundles } from '../state/gallery-store';
import { BundleCard } from '../components/BundleCard';
import { FilterBar } from '../components/FilterBar';
import './ListPage.css';

export function BundlesPage() {
  const bundles = useFilteredBundles();

  return (
    <div className="list-page">
      <header className="list-page__header">
        <h1 className="list-page__title">Bundles</h1>
        <span className="list-page__count">{bundles.length}</span>
      </header>
      <FilterBar />
      {bundles.length === 0 ? (
        <p className="list-page__empty">No bundles match the current filters.</p>
      ) : (
        <div className="list-page__grid">
          {bundles.map((b) => (
            <BundleCard key={b.id} bundle={b} />
          ))}
        </div>
      )}
    </div>
  );
}
